export const KarmaPoolProfilePictureManager = (local, setLocal, getURLBasePath) => {

    function confirmImageUploaded(imageId) {
        fetch(getURLBasePath() + 'profilePictureUploadLink', {
            method: 'POST',
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify({ finished: true })
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Server error: ${response.status} ${response.statusText}`);
                }
                return response.json();
            })
            .then((data) => {
                console.log(data);
            })
            .catch((err) => {
                console.error('Error confirming image upload:', err.message);
            });

        setLocal({ ...local, user: { ...local.user, profilePictureImageId: imageId } });
    }

    function getUploadLink(linkCallback, errorCallback) {
        fetch(getURLBasePath() + 'profilePictureUploadLink', {
            method: 'GET',
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            })
        })
            .then((response) => {
                if (!response.ok) {
                    return response.json().then(errorData => {
                        throw new Error(errorData.message || `Server error: ${response.status}`);
                    }).catch(() => {
                        throw new Error(`Server error: ${response.status} ${response.statusText}`);
                    });
                }
                return response.json();
            })
            .then((data) => {
                console.log(data);
                if (data && data.result && data.result.uploadURL) {
                    linkCallback(data);
                } else {
                    throw new Error('Invalid response format from server');
                }
            })
            .catch((err) => {
                console.error('Error getting upload link:', err.message);
                if (errorCallback) {
                    errorCallback(err);
                }
            });
    }

    return {
        confirmImageUploaded, getUploadLink
    };
}